<form [formGroup]="iniciSimulacioForm">
  <div class="col">
    <div class="fila">
      <label>{{'inici_simulacio.ambit_actuacio' | translate}}
        <select formControlName="ambit">
          <option [value]="''" hidden>{{'inici_simulacio.trieu_ambit' | translate}}</option>
          <option *ngFor="let ambit of ambits" [value]="ambit.id">{{ambit.descripcio}}</option>
        </select>
        <app-ajuda id="ajuda_ambit_actuacio" titol="{{'inici_simulacio.ambit_actuacio' | translate}}">{{'inici_simulacio.ajuda_ambit_actuacio' | translate}}</app-ajuda>
      </label>
    </div>
    <!-- <hr/> -->
    <div class="fila">

      <label>{{'inici_simulacio.dades_infant_adolescent' | translate}}</label>
      <div class="row">
        <label><input type="radio" [value]="TIPUS_INFANT_NASCITURUS" formControlName="tipus"><span>{{'inici_simulacio.tipus_nasciturus' | translate}}</span></label>
        <label><input type="radio" [value]="TIPUS_INFANT_NADO" formControlName="tipus"><span>{{'inici_simulacio.tipus_nado' | translate}}</span></label>
        <label><input type="radio" [value]="TIPUS_INFANT_ADOLESCENT" formControlName="tipus"><span>{{'inici_simulacio.tipus_infant_adolescent' | translate}}</span></label>
        <app-ajuda id="ajuda_dades_infant_adolescent" titol="{{'inici_simulacio.dades_infant_adolescent' | translate}}">
          <ul>
            <li>
              <strong>{{'inici_simulacio.ajuda_label_nasciturus' | translate}}:</strong> {{'inici_simulacio.ajuda_nasciturus' | translate}}
            </li>
            <li>
              <strong>{{'inici_simulacio.ajuda_label_nado' | translate}}:</strong> {{'inici_simulacio.ajuda_nado' | translate}}
            </li>
            <li>
              <strong>{{'inici_simulacio.ajuda_label_menor' | translate}}:</strong> {{'inici_simulacio.ajuda_menor' | translate}}        
            </li>
          </ul>
        </app-ajuda>
      </div>
    </div>
    <ng-container *ngIf="iniciSimulacioForm.value.tipus != '' && iniciSimulacioForm.value.tipus != TIPUS_INFANT_NASCITURUS">    
      <!-- <hr />   -->
      <div class="fila">
        <label *ngIf="iniciSimulacioForm.value.tipus == TIPUS_INFANT_NADO">{{'inici_simulacio.dades_nado' | translate}}</label>
        <label *ngIf="iniciSimulacioForm.value.tipus == TIPUS_INFANT_ADOLESCENT">{{'inici_simulacio.dades_infant_adolescent_parentesis' | translate}}</label>
        <br/><br/>
        <label>
          <span>{{'inici_simulacio.sexe' | translate}}
            <select formControlName="sexe">
              <option [value]="''" hidden>{{'inici_simulacio.trieu_sexe' | translate}}</option>
              <option [value]="SEXE_DONA">{{'inici_simulacio.sexe_dona' | translate}}</option>
              <option [value]="SEXE_HOME">{{'inici_simulacio.sexe_home' | translate}}</option>
            </select>
          </span>  
        </label>
      </div>
      <!-- <hr />   -->
      <div class="fila">
        <div class="row">
          <label>
            <input *ngIf="iniciSimulacioForm.value.tipus == TIPUS_INFANT_ADOLESCENT" type="radio" value="data_exacta" formControlName="tipus_edat">
            <span>{{'inici_simulacio.data_exacta' | translate}}</span>
            <input type="date" formControlName="data"/>
          </label>
          <ng-container *ngIf="iniciSimulacioForm.value.tipus == TIPUS_INFANT_ADOLESCENT">
            <label>
              <input type="radio" value="edat_estimada" formControlName="tipus_edat">
              <span>{{'inici_simulacio.edat_estimada' | translate}}</span>
              <input type="number" formControlName="edat" />
              <select formControlName="unitat_edat_estimada">
                <option [value]="''" hidden>{{'inici_simulacio.trieu_unitat_edat_estimada' | translate}}</option>
                <option *ngFor="let unitat_edat_estimada of unitats_edat_estimada" [value]="unitat_edat_estimada.id">{{unitat_edat_estimada.descripcio}}</option>
              </select>
            </label>
          </ng-container>
          <app-ajuda id="ajuda_data_naixement" titol="{{'inici_simulacio.data_naixement' | translate}}">
            <ul>
              <li>
                <strong>{{'inici_simulacio.data_exacta' | translate}}:</strong> {{'inici_simulacio.ajuda_data_exacta' | translate}}        
              </li>
              <li *ngIf="iniciSimulacioForm.value.tipus == TIPUS_INFANT_ADOLESCENT">
                <strong>{{'inici_simulacio.edat_estimada' | translate}}:</strong> {{'inici_simulacio.ajuda_edat_estimada' | translate}}        
              </li>
            </ul>
          </app-ajuda>
        </div>
      </div>
    </ng-container>
  </div>  
</form>

<div class="button-bar">
  <button class="main" (click)="goToPrevStep()" disabled>
    <i class="fas fa-angle-left prev" aria-hidden></i>{{'globals.anterior' | translate}}
  </button>
  <button class="main" (click)="goToNextStep()">{{'globals.seguent' | translate}}
    <i class="fas fa-angle-right next" aria-hidden></i>
  </button>
</div>

<vn-modal id="errors" title="{{'globals.revisar_camps' | translate}}" movible>
  <ng-container>
    <ul *ngFor="let error of errors">
      <li>{{error}}</li>
    </ul>
  </ng-container>
  <div class="button-bar">
    <button type="button" class="main" (click)="modal.close()">{{'globals.tancar' | translate}}</button>
  </div>
</vn-modal>